import React, { Component } from 'react'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import OpenVoteAnswer from './OpenVoteAnswer'
import { switchShowVotes } from '../../../../actions'

class OpenResults extends Component {
  render () {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true
    }
    const votes = this.props.votes || []

    return [
      <div
        key='0'
        className='slider-container'>
        <Slider {...settings}>
          {votes.map(vote => <OpenVoteAnswer key={vote._id} vote={vote} />)}
        </Slider>
      </div>,
      <div
        key='1'
        onClick={() => this.props.dispatch(switchShowVotes(votes))}
        className='vote-results view-all-bttn cursor-pointer'>
        {votes.length !== 0 && 'View all answers'}
      </div>
    ]
  }
}

export default connect()(OpenResults)



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/results/OpenResults.js